import React from "react";
import styled from "styled-components";
import moment from "moment";

const GridItemMultipleDays = styled.div`
    border: lightgrey solid;
    border-width: 0 0.2px 0.2px 0.2px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const GridItemOneDay = styled.div`
    border: lightgrey solid;
    border-width: 0 0.2px 0.2px 0.2px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: ${({cellDate}) => moment().format("YYYY-MM-DD:HH") === cellDate ? "rgba(255,247,198,0.5)" : "White"}
`;

const WrapperMultipleDays = styled.div`
    width: 100%;
    height: 100%;
    position: inherit;
    background-color: ${({cellDate}) => moment(cellDate).isSame(moment(),"day")
                        ? "rgba(255,219,15,0.5)"
                        : moment(cellDate).isoWeekday() === 6
                            ? "#d3d3d373"
                            : moment(cellDate).isoWeekday() === 7
                                ? "#d3d3d373"
                                : "inherit"}
`;

const WrapperOneDay = styled.div`
    width: 100%;
    height: 100%;
    position: inherit;
`;

const SingleRowDiv = ({
    cellDate,
    onClick,
    type,
    children,
}) => (
        type == 1
            ?
            <GridItemOneDay className={"car-reserved-grid"}>
                <WrapperOneDay
                    cellDate={cellDate}
                    onClick={onClick}
                >
                    {children}
                </WrapperOneDay>
            </GridItemOneDay>
            :
            <GridItemMultipleDays className={"car-reserved-grid"}>
                <WrapperMultipleDays
                    cellDate={cellDate}
                    onClick={onClick}
                >
                    {children}
                </WrapperMultipleDays>
            </GridItemMultipleDays>
    )

export default SingleRowDiv
